import Bowser from 'bowser';
import {MIN_VERSIONS} from 'shared/lib/core/supportedBrowsers.ts';
import {toast} from 'react-toastify';

function parseVersionNumber(v: string): number {
  const parts = v.split('.').slice(0, 2);
  return parseFloat(parts.join('.'));
}

export function logUnsupportedBrowser() {
  const parser = Bowser.getParser(window.navigator.userAgent);
  const name = parser.getBrowserName(true);
  const os = parser.getOSName(true) ?? 'default';
  const versionStr = parser.getBrowserVersion();

  if (!versionStr) return;

  const version = parseVersionNumber(versionStr);

  const rule = (MIN_VERSIONS as any)[name];
  if (!rule) return;

  const min = rule[os] ?? rule.default;
  if (min == null) return;

  if (version < min) {
    toast.warning('Неподдерживаемая версия браузера');
  }
}
